module.exports = __webpack_public_path__ + "img/logo-mini.a178f6d4.svg";